import React from 'react';
import { openContactPageOrganizersModal } from '@gik/calendar';

export default function useContactPageOrganizers(inkindRouteId: string): void {
  React.useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('page-organizers')) {
      // FIXME: setTimeout required because modal system not ready
      setTimeout(() => {
        openContactPageOrganizersModal(inkindRouteId);
      }, 1000);
    }
  }, [inkindRouteId]);
}
